module.exports = __webpack_public_path__ + "media/images/color_admin_v3/transparent/black-0.4-1d0ed675ff49062d78a7082a00102227.png";